module.exports = __webpack_public_path__ + "static/media/rebirth_11.4bcfa06d.jpg";